module.exports = __webpack_public_path__ + "media/images/about-1-dcc53ca3.png";